export const SIDEBAR_CONSTANTS = {
  FILES_LIMIT: 10,
  PERSONNE_LIMIT: 10,
  SEARCH_DEBOUNCE_MS: 500,
} as const;
